// import React from "react";
// import { useHeroAnimation } from "./useHeroAnimation";
// import { AnimationScene } from "./AnimationScene";
// import { HeroContent } from "./HeroContent";
// import { ActionButtons } from "./ActionButtons";
// import { AnimationControls } from "./AnimationControls";

// export const HeroAnimation = () => {
//   const { refs, state, controls } = useHeroAnimation();

//   return (
//     <div
//       id="/"
//       className="relative pt-20 md:pt-24 min-h-[70vh] md:min-h-[100vh] w-full overflow-hidden bg-gradient-to-br from-[#0a0424] to-[#130236]"
//     >
//       {/* The main animation canvas */}
//       <AnimationScene refs={refs} />

//       {/* UI Overlay */}
//       <div className="absolute inset-0 z-20 pointer-events-none">
//         <HeroContent />
//         <ActionButtons />
//       </div>

//       {/* Interactive Controls */}
//       <AnimationControls refs={refs} state={state} controls={controls} />
//     </div>
//   );
// };


import React from "react";
import { useHeroAnimation } from "./useHeroAnimation";
import { AnimationScene } from "./AnimationScene";
import { HeroContent } from "./HeroContent";
import { ActionButtons } from "./ActionButtons";
import { AnimationControls } from "./AnimationControls";

export const HeroAnimation = () => {
  const { refs, state, controls } = useHeroAnimation();

  return (
    <div
      id="/"
      className="relative pt-20 md:pt-24 min-h-[70vh] md:min-h-[100vh] w-full overflow-hidden bg-gradient-to-br from-[#0a0424] to-[#130236]"
    >
      {/* 
        This new container is the anchor for the entire animation. 
        Its 'position: relative' establishes the coordinate system for all 
        absolutely positioned children, like the player character.
      */}
      <div id="hero-animation-container" ref={refs.container} className="relative w-full h-full">
        {/* The main animation canvas */}
        <AnimationScene refs={refs} />

        {/* UI Overlay */}
        <div className="absolute inset-0 z-20 pointer-events-none">
          <HeroContent />
          <ActionButtons />
        </div>
      </div>


      {/* Interactive Controls */}
      <AnimationControls refs={refs} state={state} controls={controls} />
    </div>
  );
};